export default __webpack_public_path__ + "static/media/caret-down.35e012d8.svg";